module.exports = __webpack_public_path__ + "img/w.d9a3c6c1.svg";